import React from "react";
import { useQuery, gql } from "@apollo/client";
import Loader from "../../Loader";

const GET_PAYMENT_FLOW_ANALYTICS = gql`
  query getPaymentFlowAnalytics($data: PaymentFlowAnalyticsInput!) {
    getPaymentFlowAnalytics(data: $data) {
      status
      message
      data {
        paymentMethod
        status
        count
      }
    }
  }
`;

const PaymentFlowAnalyticsWidget = ({ filters }) => {
  const { data, loading, error } = useQuery(GET_PAYMENT_FLOW_ANALYTICS, {
    variables: { 
      data: {
        startDate: filters.startDate, 
        endDate: filters.endDate,
        employeeIds: filters.employeeId ? [filters.employeeId] : filters.employeeIds
      }
    },
    fetchPolicy: "network-only",
  });

  if (loading) return <div className="p-6"><Loader /></div>;
  if (error) return <div className="text-red-500 p-6">Error loading payment analytics</div>;

  const analytics = data?.getPaymentFlowAnalytics?.data || [];

  // Group by flow
  const flows = {
    QR_TOPUP: { title: "QR Extra Top-up", paidCount: 0, refundedCount: 0 },
    PAYMENT_LINK: { title: "SMS Payment Link", paidCount: 0, refundedCount: 0 },
    QR_CODE: { title: "QR Code Flow", paidCount: 0, refundedCount: 0 },
    PAY_LATER: { title: "Pay Later Flow", paidCount: 0, refundedCount: 0 },
    CHECKOUT: { title: "Pre-Booking Checkout", paidCount: 0, refundedCount: 0 },
  };

  analytics.forEach(item => {
    if (flows[item.paymentMethod]) {
      if (item.status === 'PAID') {
        flows[item.paymentMethod].paidCount += item.count;
      } else if (item.status === 'REFUNDED') {
        flows[item.paymentMethod].refundedCount += item.count;
      }
    }
  });

  return (
    <div className="bg-[#1C1C1E] p-6 rounded-2xl shadow-lg border border-gray-800">
      <h3 className="text-[#FBB033] font-bold text-xl mb-6">Payment Flow Analytics</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        {Object.entries(flows).map(([key, flow]) => (
          <div key={key} className="bg-[#232325] p-5 rounded-xl border border-gray-700 flex flex-col hover:border-gray-600 transition-colors">
            <h4 className="text-gray-400 font-semibold text-sm text-center mb-4 h-10 flex items-center justify-center border-b border-gray-700 pb-2">{flow.title}</h4>
            <div className="flex justify-between items-center w-full px-2">
              <div className="flex flex-col items-center">
                <span className="text-gray-500 text-xs mb-1">Paid</span>
                <span className="text-2xl font-bold text-green-400">{flow.paidCount}</span>
              </div>
              <div className="h-8 w-px bg-gray-700"></div>
              <div className="flex flex-col items-center">
                <span className="text-gray-500 text-xs mb-1">Refunded</span>
                <span className="text-2xl font-bold text-blue-400">{flow.refundedCount}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentFlowAnalyticsWidget;
